import { render, staticRenderFns } from "./DatepickerFallback.vue?vue&type=template&id=364fbbd8"
import script from "./DatepickerFallback.vue?vue&type=script&lang=js"
export * from "./DatepickerFallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports